import { render } from "./notifications.vue?vue&type=template&id=21dbe8ac"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__